import pac from '../../package.json'

export const getAppVersion = (): string => {
  const [v, build] = pac.version.split('-')

  if (!build) return `version ${v}`

  return `version ${v} build ${build}`
}
